import { useMemo } from 'react';
import { useQueryGetSubscriptionsV2 } from 'state/internal/getSubscriptions';

export const useIsShopPageAvailable = () => {
  const {
    data: shopifySubscriptions = [],
    // Note: using isLoading instead of isPending is intentional. We want to
    // know if there is no cached data AND a fetch is in progress.
    isLoading: isLoadingV2
  } = useQueryGetSubscriptionsV2();

  const activeV2 = useMemo(
    () =>
      shopifySubscriptions
        ?.filter((i) => i.is_active)
        .sort((a, b) => a.next_order_date - b.next_order_date) || [],
    [shopifySubscriptions]
  );

  return {
    isLoading: isLoadingV2,
    isShopPageAvailable: Boolean(!isLoadingV2 && activeV2.length)
  };
};
